import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    marginLeft: "15px",
    fontWeight: "bold",
    height: "40px",
    fontSize: "0.75rem",
    padding: "5px 15px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
}));

export default function AddButton(props) {
  const { handleSubmit, children, disabled } = props;

  const classes = useStyles();

  return (
    <Button
      className={classes.submitButton}
      onClick={() => {
        handleSubmit();
      }}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

AddButton.propTypes = {
  inputTitle: PropTypes.any,
};
